<template>
  <div class="main-layout yx-student-predicted-page">
    <el-card class="box-inner">
      <c-title slot="header" title="预报到统计" :back="false"></c-title>
      <div class="div-scroll">
        <div class="predicted-list">
          <div
            class="pre-item pre-static-item"
            v-for="(item, index) in predictedList"
            :key="item.id"
            @click="goto(item)"
          >
            <div class="item-index">
              <img
                :src="
                  require('../../../../../assets/images/prediect/' +
                    (index + 1) +
                    '.png')
                "
                alt=""
                class="index-img"
                :class="{ first: index == 0 }"
              />
            </div>
            <div class="item-left">
              <p class="title ellipsis">{{ item.name }}</p>
              <p class="desc ellipsis">
                <span
                  >已完成：<span class="green">{{ item.doneNum }}</span></span
                >
                <span
                  >未完成：<span class="red">{{ item.todoNum }}</span></span
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import CTitle from "@/components/CTitle";
import { mapState } from "vuex";
export default {
  components: {
    CTitle,
  },
  data() {
    return {
      predictedList: [],
      finance: {
        paidNum: 0,
        oweNum: 0,
        paidPartNum: 0,
      },
      totalPaidAmount: 0,
      totalOweAmount: 0,
      armyNum: 0,
      enrollmentYear: null,
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE", "_CURRENTYEAR","_CURRENT_ACADEMIC"]),
  },
  created() {
    this.getPredictedList();
    // this.getFinanceData();
  },
  mounted() {},
  methods: {
    goto(data) {
      console.log(data);
      if (data.url) {
        this.$router.push(data.url + "/" + data.id);
      }
    },
    getPredictedList() {
      let params = {
        academicDegree: this._CURRENT_ACADEMIC,
        enrollmentYear: this._CURRENTYEAR[0].value,
      };
      this.$http
        .get("/welcome-forecast/statistics/getForecastLinkDoneNum", {
          params,
        })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            // console.log(res);
            if (res.data) {
              let data = res.data;
              this.predictedList = data;
            }
          } else {
            this.$message.error(`${res.msg}`);
          }
        })
        .catch((err) => {
          this.$message.error(`${err}`);
        });
    },
  },
};
</script>
